import React, { useEffect, useRef } from "react";
import "./NameScramble.css";

// ====== CONFIGURATION ======
const NAME = "Abhinav Rathee";
const DURATION = 13000; // ms (even slower, luxury feel)
const FPS = 18;        // Very low FPS for ultra smooth, gentle transitions
const SCRAMBLE_STEPS = 4;


// Character pools: Katakana, a-z (lowercase only)
const CHAR_POOLS = {
  katakana: "アイウエオカキクケコサシスセソナニヌネノラリルレロ",
  latin: "abcdefghijklmnopqrstuvwxyz"
};


const NameScramble = () => {
  const ref = useRef();
  useEffect(() => {
    const letters = NAME.split("");
    let frame = 0;
    const totalFrames = Math.round((DURATION / 1000) * FPS);
    let raf;

    const startScramble = () => {
      if (raf) cancelAnimationFrame(raf);
      frame = 0;
      animate();
    };

    function getScrambleChar(target, closeness) {
      if (target === " ") return " ";
      if (closeness === SCRAMBLE_STEPS - 1) return target;
      const pool = CHAR_POOLS.katakana + CHAR_POOLS.latin;
      return pool[Math.floor(Math.random() * pool.length)];
    }

    function animate() {
      let display = "";
      for (let i = 0; i < letters.length; i++) {
        const t = i / (letters.length - 1);
        const slowReveal = Math.floor((0.05 + 0.95 * Math.pow(t, 4)) * totalFrames);
        const progress = Math.max(0, frame - slowReveal + SCRAMBLE_STEPS);
        const closeness = Math.min(SCRAMBLE_STEPS - 1, Math.floor(progress / (SCRAMBLE_STEPS)));
        if (frame >= slowReveal) {
          display += letters[i];
        } else {
          display += getScrambleChar(letters[i], closeness);
        }
      }
      if (ref.current) ref.current.textContent = display;
      if (frame < totalFrames + 60) {
        frame++;
        raf = requestAnimationFrame(animate);
      } else {
        if (ref.current) ref.current.textContent = NAME;
      }
    }

    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        startScramble();
      }
    };

    ref.current.textContent = "".padEnd(letters.length, " ");
    startScramble();

    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => {
      if (raf) cancelAnimationFrame(raf);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);
  return (
    <span className="name-scramble" aria-label={NAME} ref={ref}></span>
  );
};

export default NameScramble;
